import { useEffect } from "react";
import Card from './Controls/Card'
import AOS from 'aos';
import "aos/dist/aos.css";
import './css/tailwind.css'
import './App.css'
import './fonts/BentonSans-Regular.otf'
import './fonts/BentonSans-Medium.otf'
// import header_image from './Images/Header.png'
// import footer_image from './Images/Footer.png'
// import moto_image from './Images/Moto.jpg'
// import bateria_image from './Images/Bateria.jpg'

// export interface NotificationContextData {
//   isShowNotification: boolean;
//   fetchNotificacion: (isShow: boolean) => void;
// }

// export const notificationContextDefaultValue: NotificationContextData = {
//   isShowNotification: false,
//   fetchNotificacion: () => null,
// }

// export const AppContext = React.createContext<NotificationContextData>(notificationContextDefaultValue)

function App() {

//  const [isShowNotification, setNotification] = useState<boolean>(false);

//  const fetchNotificacion = (isShowNotification:boolean) => {
//   setNotification(isShowNotification)
//  }

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  // useEffect(() => {
  //   alert(isShowNotification)
  // }, [isShowNotification]);

  return (
    <>
    {/* <AppContext.Provider value={{isShowNotification,fetchNotificacion}}> */}
      <div className="flex flex-col h-screen justify-between">
      <header>
        <div className="bg-center bg-no-repeat md:bg-cover lg:bg-cover xl:bg-cover h-24 xs:h-28 sm:h-40 md:h-32 lg:h-36 xl:h-40 bg-header_xxs xs:bg-header_xs sm:bg-header_sm md:bg-header_md lg:bg-header_lg xl:bg-header_xl"></div>
        {/* <img alt="" className="object-top object-scale-down h-20 w-full" src={header_image} /> */}
      </header> 
      <div className="grid md:flex lg:flex xl:flex grid-cols-1 justify-center">
      {/* <div className="flex md:flex lg:flex xl:flex w-full md:w-1/5 lg:w-1/4 xl:w-1/4 justify-center items-center pb-10 md:pb-0" data-aos="fade-up"
     data-aos-duration="3000"> */}
       <div className="grid grid-cols-1 md:mr-5 xs:h-56 sm:h-72 xxs:h-52 md:bg-contain lg:bg-contain xl:bg-contain justify-center md:w-1/5 lg:w-2/5 xl:w-3/5 xl:mt-24 md:h-84 lg:h-88 xl:h-96 md:flex lg:flex xl:flex w-full md:w-1/5 bg-center bg-no-repeat bg-moto_xxs xs:bg-moto_xs sm:bg-moto_sm md:bg-moto_md lg:bg-moto_lg xl:bg-moto_xl xxl:bg-moto_xxl"></div>
      {/* <img alt="" className="transform translate-x-4 translate-y-4 object-top object-scale-down" src={moto_image} /> */}
      {/* </div> */}
      <div className="bg-center bg-no-repeat flex md:flex lg:flex xl:flex w-full justify-center tems-center pt-3 md:w-3/5">
      <Card></Card>
      </div>
      {/* <div className="flex md:flex lg:flex xl:flex w-full md:w-1/5 lg:w-1/4 xl:w-1/4 justify-center items-center pt-10 md:pb-0" data-aos="fade-down"
     data-aos-duration="3000"> */}
       <div className="grid-cols-1 items-center md:ml-3 h-44 md:bg-contain lg:bg-contain xl:bg-contain xxs:mb-0 xs:mb-0 mb-16 lg:mt-24 xl:mt-40 md:mt-40 justify-center md:w-1/5 lg:w-2/5 xl:w-3/5 md:flex lg:flex xl:flex w-full md:h-52 lg:h-60 xl:h-64 bg-center bg-no-repeat bg-bateria_xxs xs:bg-bateria_xs sm:bg-bateria_sm md:bg-bateria_md lg:bg-bateria_lg xl:bg-bateria_xl"></div>
      {/* <img alt="" className="object-top object-scale-down" src={bateria_image} /> */}
      {/* </div> */}
      </div>
      <footer>
      <div className="bg-center bg-no-repeat md:bg-cover lg:bg-cover xl:bg-cover h-40 xs:h-36 sm:h-48 md:h-36 lg:h-48 xl:h-52 bg-footer_xxs xs:bg-footer_xs sm:bg-footer_sm md:bg-footer_md lg:bg-footer_lg xl:bg-footer_xl"></div>
        {/* <img alt="" className="object-bottom object-scale-down h-24 w-full" src={footer_image} /> */}
      </footer> 
    </div>
    {/* </AppContext.Provider> */}
    
    </>
  );
}

export default App;
